import React from 'react'
import { MdExpandMore } from '@react-icons/all-files/md/MdExpandMore'
type Props = {
  expanded?: boolean
  onClick?: () => void
}
export default function ExpandToggle(props: Props): React.ReactElement<'div'> {
  const expanded = props.expanded || null
  return (
    <div
      className="e2-expand"
      data-expanded={expanded}
      onClick={
        props.onClick
          ? e => {
              e.stopPropagation()
              if (props.onClick) props.onClick()
            }
          : undefined
      }
    >
      <MdExpandMore />
    </div>
  )
}
